<template>
  <basic-dialog v-model="dialog" :actionButtons="actionButtons" :loading="loading"
                :title="category.id ? $t('categories.edit') : $t('categories.create')">

    <v-card-text class="pt-4">
      <category-edit-form ref="categoryEditForm" v-model="category"/>
    </v-card-text>

  </basic-dialog>
</template>

<script>
import BasicDialog from "@/components/BasicDialog";
import categoryApi from "@/api/category";
import CategoryEditForm from "@/components/Category/CategoryEditForm";
import TranslationService from "@/service/translation.service";

export default {
  name: "CategoryEditDialog",
  components: {CategoryEditForm, BasicDialog},
  data() {
    return {
      loading: false,
      dialog: false,
      category: {},
      actionButtons: {
        cancel: {
          click: this.close,
        },
        save: {
          click: this.save
        }
      }
    };
  },
  computed: {},
  methods: {
    close() {
      this.dialog = false;
    },
    open(item) {
      if (!item) this.category = {
        nameTid: null,
        descriptionTid: null,
        parentCategory: null,
        engineName: null,
        type: null,
      };
      else this.category = {...item};

      this.dialog = true;
    },
    async save() {

      if (!this.$refs.categoryEditForm.$refs.form.validate()) return;
      this.loading = true;
      try {
        await TranslationService.saveNewTranslations();

        if (this.category?.id) {
          await categoryApi.updateCategory(this.category.id, this.category);
        } else {
          await categoryApi.addCategory(this.category);
        }

        this.dialog = false;
      } catch (e) {
        this.$handleApiError(e, this.$t('errors.error_category_save_failed'));
        console.error(e);
      }
      this.loading = false;
      this.$emit('refresh');
    }
  }
}
</script>

<style scoped>

</style>
